<template lang="pug">
.addressMapCom
    el-form-item(:label='labeltext',:required="isrequire")
      .el-row(style="width: 400px")
        el-col( :span="8")
            el-form-item(prop="streetId",style="margin-bottom:0;")
                el-select(:disabled='readonly',v-model='baseForm.streetId',   size='mini', style='width:120px;margin:0 10px 0 0', @change='dwshiValue')
                    el-option(v-for='item in streetTree', :label='item.label', :key='item.orgId', :value='item.orgId')
                        
        el-col( :span="8")
            el-form-item(prop="communityId",style="margin-bottom:0;")
                el-select(:disabled='readonly',v-model='baseForm.communityId',   size='mini', style='width:120px;margin:0 10px 0 0', @change='dwquValue')
                    el-option(v-for='item in street2Arr', :label='item.label', :key='item.orgId', :value='item.orgId')

        el-col( :span="8")
            el-form-item(prop="gridId",style="margin-bottom:0;")
                el-select(:disabled='readonly',v-model='baseForm.gridId',   size='mini', style='width:120px;margin:0 10px 0 0', @change='dwjdValue')
                    el-option(v-for='item in street3Arr', :label='item.label', :key='item.orgId', :value='item.orgId')

        el-col( :span="24")
            el-form-item(prop="address",style="margin-bottom:0;margin-top:20px;")
                el-input(:disabled='readonly', @blur='transLocation',   v-model='baseForm.address' )

    el-form-item( prop='lnglat')
        div(style='width:400px;height:200px;',:id='mapid') 

</template>
<script>
/*** 父级传参
 * fatherdatas:{
 *       mapid: "address112", //地图的id
        readonly: false, // 只读设置
        city: "cityName1", // 城市的动态参数key
        area: "areaName1", // 区/县的动态参数key
        street: "streetName1", // 街道的动态参数key
        address: "addressDetail1", // 详细地址的动态参数key
        labeltext :'办理地点' , // 办理地点的prop的label
        // 地址的回显
        fatherdata: {
          cityName: "",
          areaName: "",
          streetName: "",
          addressDetail: ""
        }
 * }
 * 
 */
// import { addressMix } from "@/mixins/addressMix2.js";
import { findAddressByParentId } from "@/api/http";
import { post } from "@/api/requrestHttp";
export default {
  name: "addressMapCom",
  //   mixins: [addressMix],
  props: {
    isrequire: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    rulesrequire: {
      type: Boolean,
      default: false
    },
    city: {
      type: String,
      default: "cityName"
    },
    area: {
      type: String,
      default: "areaName"
    },
    street: {
      type: String,
      default: "streetName"
    },
    address: {
      type: String,
      default: "address"
    },
    labeltext: {
      type: String,
      default: "办理地点:"
    },
    fatherdata: {
      type: Object,
      default: null
    },
    mapid: {
      type: String,
      default: ""
    },
    streetTree: {
      type: Array,
      default() {
        return [];
      }
    },
    zuzhiId: {
      type: String,
      default: "0"
    }
  },
  components: {},
  data() {
    return {
      option11: [],
      option12: [],
      option13: [],
      option14: [],
      text: "",
      baseForm: {
        streetId: "",
        communityId: "",
        gridId: "",
        latitude: 0,
        longitude: 0
      },
      nochangeSelect: false,
      mapDataObj: {},
      // 选择街道
      street2Arr: [],
      street3Arr: [],
      // 当前网格Id
      nowId: "0"
    };
  },
  methods: {
    // 获取当前网格相关信息
    getGridInfo(id) {
      return post("/admin/org/info/findOrgById", { id });
    },
    async ininFunc() {
      if (this.mapid) {
        this.mapDataObj = {
          mapcontainer: null,
          mapmarker: null,
          geolocation: null,
          polygon: null
        };
      }
    },
    async initMap() {
      const { content } = await this.getGridInfo(this.nowId);
      console.log('content',content)
      if (content.id) {
        let newbase = {};
        const lnglat = content.gridOfficeCordinate
          ? content.gridOfficeCordinate.split(",")
          : ["0", "0"];
        this.handleStreet(this.nochangeSelect ? this.fatherdata : content);
        const needData = {
          streetId: content.streetId ? content.streetId + "" : null,
          communityId: content.communityId ? content.communityId + "" : null,
          gridId: content.gridId ? content.gridId + "" : null,
          latitude: lnglat[1],
          longitude: lnglat[0],
          address: this.nochangeSelect
            ? this.fatherdata.address
            : content.gridOfficeName,
          pointPosition: content.pointPosition,
          label: content.label,
          gridColour: content.gridColour
        };
        console.log('needData',needData);
        
        this.nochangeSelect = false;
        this.baseForm = needData;
      } else {
        this.baseForm = {};
      }
      this.$nextTick(() => {
        // this.viewMapTemp = true
        this.mapInit(this.mapid);
      });
    },
    handleStreet(fatherdata) {
      let arr2 = [],
        arr3 = [];
      if (fatherdata.streetId) {
        this.streetTree.forEach(item => {
          if (item.orgId == fatherdata.streetId) {
            arr2 = item.children;
          }
        });
        // 如果有社区id
        if (fatherdata.communityId) {
          for (let i = 0; i < arr2.length; i++) {
            let item = arr2[i];
            if (fatherdata.communityId == item.orgId) {
              arr3 = item.children;
            }
          }
        }
      }
      this.street2Arr = arr2;
      this.street3Arr = arr3;
    },
    rebackFunc() {
       console.log(this.baseForm);
      // this.$emit("fun", this.baseForm);
    },
    setmarkerFunc(longitude, latitude) {
      let mapObjs = this.mapDataObj;
      mapObjs.mapmarker.setPosition([longitude, latitude]);

      mapObjs.mapcontainer.add(mapObjs.mapmarker);
      mapObjs.mapcontainer.setFitView(mapObjs.mapmarker);
    },
    //初始化地图插件的方法
    mapInit(containerId) {
      let mapObjs = this.mapDataObj;
      mapObjs.mapcontainer = new AMap.Map(containerId, {
        resizeEnable: true,
        zoom: 1
      });
      mapObjs.mapmarker = new AMap.Marker({
        // position: [longitude, latitude],
        map: mapObjs.mapcontainer
      });
      if (this.baseForm.longitude && this.baseForm.latitude) {
        this.setmarkerFunc(this.baseForm.longitude, this.baseForm.latitude);
      } else {
        mapObjs.mapcontainer.plugin("AMap.Geolocation", () => {
          let geolocation = new AMap.Geolocation({
            enableHighAccuracy: true, //是否使用高精度定位，默认:true
            timeout: 10000 //超过10秒后停止定位，默认：无穷大
            // buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
            // zoomToAccuracy: false, //定位区域
            // buttonPosition: "RB"
          });
          mapObjs.mapcontainer.addControl(geolocation);

          geolocation.getCurrentPosition();

          AMap.event.addListener(geolocation, "complete", data => {
            this.setmarkerFunc(data.position.getLng(), data.position.getLat());
          }); //返回定位信息
        });
      }
      if (this.baseForm.pointPosition) {
        const polygonArr = [];
        // 添加划区
        this.baseForm.pointPosition.split(",").forEach(e => {
          polygonArr.push(e.split(":"));
        });
        mapObjs.polygon = new AMap.Polygon({
          map: mapObjs.mapcontainer,
          path: polygonArr, //设置多边形边界路径
          strokeColor: "#" + this.baseForm.gridColour, //线颜色
          strokeOpacity: 0.2, //线透明度
          strokeWeight: 3, //线宽
          fillColor: "#" + this.baseForm.gridColour, //填充色
          fillOpacity: 0.35, //填充透明度
          extData: {
            name: this.baseForm.label
          }
        });
      }
      this.rebackFunc();
      if (this.readonly) {
        return;
      }
      //定义地图坐标点击事件
      mapObjs.polygon.on("click", e => {
        // console.log(e);

        this.baseForm.longitude = e.lnglat.getLng();
        this.baseForm.latitude = e.lnglat.getLat();

        // 这里通过高德 SDK 完成。
        let geocoder = new AMap.Geocoder({
          radius: 1000,
          extensions: "all"
        });

        geocoder.getAddress(
          [this.baseForm.longitude, this.baseForm.latitude],
          (status, result) => {
            if (status === "complete" && result.info === "OK") {
              if (result && result.regeocode) {
                this.$set(
                  this.baseForm,
                  "address",
                  result.regeocode.formattedAddress
                );
                this.rebackFunc();
              }
            }
          }
        );
        this.setmarkerFunc(this.baseForm.longitude, this.baseForm.latitude);
      });
    },
    //根据输入地址转换经纬度并标记
    transLocation(e) {
      if (!e) return;
      this.baseForm.cityLabel = this.baseForm.cityLabel || "";
      this.baseForm.areaLabel = this.baseForm.areaLabel || "";
      this.baseForm.streetLabel = this.baseForm.streetLabel || "";

      //   this.$set(this.baseForm, "addressDetail", e.target.value);
      let searchKey =
        this.baseForm.cityLabel +
        this.baseForm.areaLabel +
        this.baseForm.streetLabel +
        e.target.value;

      //   console.log(searchKey);
      const that = this;
      let geocoder = new AMap.Geocoder({
        radius: 1000,
        extensions: "all"
      });

      geocoder.getLocation(searchKey, (status, result) => {
        if (status === "complete" && result.geocodes.length) {
          let lnglat = result.geocodes[0].location;
          if (!this.mapDataObj.polygon.contains(lnglat)) {
            this.$message({
              message: "地址不在范围内",
              type: "warning"
            });
            this.baseForm.address = "";
          } else {
            this.baseForm.longitude = lnglat.lng;
            this.baseForm.latitude = lnglat.lat;
            this.setmarkerFunc(lnglat.lng, lnglat.lat);
          }
        } else {
          this.$message({
            message: "获取坐标失败，请手动获取",
            type: "error"
          });
          this.baseForm.longitude = "";
          this.baseForm.latitude = "";
          //   this.baseForm.addressDetail = "";
          this.$set(this.baseForm, "address", "");
        }
        this.rebackFunc();
      });
    },
    dwshiValue(val) {
      // for (let i = 0; i < this.streetTree.length; i++) {
      //   let item = this.streetTree[i];
      //   if (val === item.orgId) {
      //     this.street2Arr = item.children;
      //   }
      // }
      console.log('val',val)
      this.nowId = val;
      this.initMap();
    },
    dwquValue(val) {
      // for (let i = 0; i < this.street2Arr.length; i++) {
      //   let item = this.street2Arr[i];
      //   if (val === item.orgId) {
      //     this.street3Arr = item.children;
      //   }
      // }
      this.nowId = val;
      this.initMap();
    },
    dwjdValue(val) {
      console.log(val);
      this.nowId = val;
      this.initMap();
    },
    async selectDwJd() {
      this.option14 = [];
      let res = await findAddressByParentId({
        id: this.baseForm.areaId
      });
      //   console.log(res);
      this.option14 = this.option14.concat(res.content.list);
    },
    //获取单位地址查询
    async selectDwSheng() {
      this.option11 = [];
      let res = await findAddressByParentId({
        id: "0"
      });
      if (!res.content) return;
      this.option11 = this.option11.concat(res.content.list);
    },
    async selectDwShi() {
      this.option12 = [];
      let res = await findAddressByParentId({
        id: "1"
      });
      if (!res.content) return;
      //   console.log(res);
      this.option12 = this.option12.concat(res.content.list);
    },
    async selectDwQu() {
      this.option13 = [];
      let res = await findAddressByParentId({
        id: "2"
      });
      if (!res.content) return;
      //   console.log(res);
      this.option13 = this.option13.concat(res.content.list);
    },
    destroyMap() {
      if (this.mapDataObj.mapcontainer) {
        this.mapDataObj.mapcontainer.destroy();
      }
      this.baseForm = {};
    }
  },
  mounted() {
    this.ininFunc();
  },
  watch: {
    mapid(val) {
      if (val) {
        console.log("mapid==", val);
        // this.ininFunc();
        // this[val] = {
        //   mapcontainer: null,
        //   mapmarker: null,
        //   geolocation: null
        // };
        // this.$nextTick(() => {
        //   this.mapInit(val);
        // });
      }
    },
    zuzhiId(val) {
      if (val && val !== "0") {
        console.log("拿到了组织id");
        this.nowId = val;
        this.initMap();
        this.fatherdata.isEdit ? (this.nochangeSelect = true) : null;
      }
    }
  }
};
</script>
<style lang="less">
</style>